var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.375C16 13.0293 11.182 16.977 10.1807 17.529C10.1253 17.5596 10.063 17.5756 9.99963 17.5756C9.93628 17.5756 9.87397 17.5596 9.8185 17.529C8.8165 16.977 4 13.125 4 9.375C4 5.625 6.25 3 10 3C13.75 3 16 5.625 16 9.375Z",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.5C7.5 9.16304 7.76339 9.79893 8.23223 10.2678C8.70107 10.7366 9.33696 11 10 11C10.663 11 11.2989 10.7366 11.7678 10.2678C12.2366 9.79893 12.5 9.16304 12.5 8.5C12.5 7.83696 12.2366 7.20107 11.7678 6.73223C11.2989 6.26339 10.663 6 10 6C9.33696 6 8.70107 6.26339 8.23223 6.73223C7.76339 7.20107 7.5 7.83696 7.5 8.5V8.5Z",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellAddress);
export default __webpack_public_path__ + "static/media/icn_table_cell_address.3b29f00689c25b39356a0b37406b42f8.svg";
export { ForwardRef as ReactComponent };